import { render, staticRenderFns } from "./LostItemModal.vue?vue&type=template&id=67008fef&scoped=true"
import script from "./LostItemModal.vue?vue&type=script&lang=js"
export * from "./LostItemModal.vue?vue&type=script&lang=js"
import style0 from "./LostItemModal.vue?vue&type=style&index=0&id=67008fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67008fef",
  null
  
)

export default component.exports